import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { academylist, workerbulkupload, workeruploadlog } from "../../../services/admin";
import Select from "react-select";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";

export default function Workersbulkupload() {
  const [errmsg, setErrMsg] = useState("");
  const [efile, setEFile] = useState("");
  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [filterProduct, setFilterProduct] = useState([]);

  const columnDefs = [
    {
      headerName: "Upload Excel",
      width: 170,
      field: "excel_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              className="excelfailed text-success"
              href={params.data.path + params.value}
              download={params.data.path + params.value}
              target="_blank"
            >
              Click to Download
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Failed Excel",
      width: 150,
      field: "mandatory_excel",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return (
            <div className="text-center">
              <a
                className="excelfailed text-danger"
                href={params.data.path + params.value}
                download={params.data.path + params.value}
                target="_blank"
              >
                Click to Download
              </a>
            </div>
          );
        }
      },
    },
    {
      headerName: "Uploaded on",
      width: 150,
      field: "created_at",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy hh:mm:ss A");
        }
      },
    },
    {
      headerName: "Uploaded by",
      width: 150,
      field: "user",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];
  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setAList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
              }
            }
           
          }
        }
      });
    }
  }, [])
  function idcardfile(event) {
    setErrMsg("");
    setEFile("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(xlsx|xls)$/i)) {
        setEFile(event.target.files[0]);
      } else {
        setErrMsg("Upload excel should be xls or xlsx format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setErrMsg("Upload excel size should be less than 5MB");
      }
    }
  }
  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e);

    } else {
      setAcaID("");
      listall("");
    }
  }
  function submitworker(e) {
    e.preventDefault();
    setErrMsg("");
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setErrMsg("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }
    if (valid === "") {
      if (efile !== "") {
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && acaid !== "") {
          temp.append("academy_id", acaid.value);
        }
        temp.append("excel_name", efile);
        workerbulkupload(temp).then((res) => {
          if (res.status === true) {
            setEFile("");
            setAcaID("");
            listall(acaid);
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        })
      } else {
        setErrMsg("Please Upload Excel");
      }
    }

  }
  function listall(aid) {
    setFilterProduct([]);

    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("type", 1);

    workeruploadlog(temp).then((response) => {
      if (response.status === true) {
        setFilterProduct(response.data.details);
      }
    });
  }
  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Workers Bulkupload</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Workers</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
          Workers Bulkupload
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <div className="row">
                <div className="col-md-8">
                  <h2 className="main-content-title tx-24 mg-b-5">
                    Workers Excel Upload
                  </h2>
                </div>
                <div className="col-md-4">
                  <div className="text-right me-4">
                    <a className="btn btn-secondary" href={require("../../../assets/images/Worker_BulkUpload.xlsx")} download>
                      Download Sample Excel
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                {localStorage.getItem("Role") === "1" && (
                  <div className="col-xl-6 col-sm-6">
                    <div className="mb-3">
                      <label className="form-label">
                        Select Academy
                        <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="default-select"
                        placeholder="Select Academy"
                        value={acaid}
                        options={alist}
                        onChange={handleAcademy}
                        isSearchable={true}
                        isClearable
                        hidden
                      />

                    </div>
                  </div>
                )}
                <div className="col-xl-6 col-sm-6">
                  <div className="mb-3">
                    <label className="form-label">
                      Upload Excel<span className="text-danger"> *</span>
                    </label>
                    <input
                      type="file"
                      className="form-control buttion-file"
                      accept=".xlsx, .xls"
                      onChange={idcardfile}
                    />
                  </div>
                </div>

              </div>
              {errmsg !== "" && <span className="text-danger">{errmsg}</span>}
              <div className="res-right mt-2 me-4 mb-2">
                <button className="btn btn-success" onClick={submitworker}>
                  Submit
                </button>
              </div>
            </div>
          </div>
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="card-header ">
              <h2 className="main-content-title tx-24 mg-b-5">
                    Upload Preview
                 </h2>
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
